import * as React from 'react';
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

export function TemporaryDrawer() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const menuItems = [
    { text: 'HOME', route: '/' },
    { text: 'ABOUT', route: '/about' },
    { text: 'PROJECTS', route: '/projects' },
    { text: 'TECH', route: '/tech' },
    { text: 'CONTACT', route: '/contact' },
  ];

  const DrawerList = (
    <Box
      sx={{ width: "250px" }}
      role="presentation"
      onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
      className="bg-black"
      height={10000}
    >
      <List>
        {menuItems.map((item, index) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              sx={{
                backgroundColor: "blue",
                color: "white",
                "&:hover": { backgroundColor: "darkblue" },
                borderRadius: "8px",
                m: 1,
                justifyContent: "center",
              }}
              onClick={() => {
                navigate(item.route);
                setOpen(false); // close drawer after navigation
              }}
            >
              <ListItemText primary={item.text} sx={{ textAlign: "center" }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {['RESUME'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton
              sx={{
                backgroundColor: "green",
                color: "white",
                "&:hover": { backgroundColor: "darkgreen" },
                borderRadius: "8px",
                m: 1,
                justifyContent: "center",
              }}
              onClick={() => window.open('https://drive.google.com/file/d/1XcwLQtBqibiEk9oUx4DNreJcX3Tk40jD/view?usp=sharing', '_blank')}
            >
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon sx={{ color: "white" }} /> : <MailIcon sx={{ color: "white" }} />}
              </ListItemIcon>
              <ListItemText primary={text} sx={{ textAlign: "center" }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div className='bg-black'>
      <Button onClick={toggleDrawer(true)}>
        <span className='bi bi-list' style={{ fontSize: "44px" }}></span>
      </Button>
      <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
